import { useEffect } from 'react'
import Input from 'components/input/input/input'
import InputGroup from 'components/input-group/input-group'
import Infoblock from 'components/infoblock/infoblock'
import Search from 'components/input/search/search'
import countries, { eu, global } from 'utils/data/countries'
import states from 'utils/data/states'
import { parseFormEvent } from 'utils/helpers'
import useCheckout from 'utils/checkout'

const getDeliveryType = countryCode => {
    return eu.includes(countryCode) ? 'eu' : 'global'
}

export default function OutsideDelivery({ handleDeliveryChange, availableDeliveries, info, setInfo }) {
    const isEu = !!availableDeliveries.find(d => d.value === 'eu')
    const isGlobal = !!availableDeliveries.find(d => d.value === 'global')
    const { setup } = useCheckout()

    useEffect(() => {
        if (info.outside_country) {
            handleDeliveryChange(getDeliveryType(info.outside_country), 'outside')
        }
    }, [])

    const hasStates = ['US', 'AU', 'CA'].includes(info.outside_country)
    let availableCodes = []
    if (isEu) {
        availableCodes = eu
    }
    if (isGlobal) {
        availableCodes = [...availableCodes, ...global]
    }
    const useCountries = countries.filter(country => availableCodes.includes(country.value))

    const handleChange = e => {
        const { name, value } = parseFormEvent(e)
        if (name === 'outside_country') {
            handleDeliveryChange(getDeliveryType(value), 'outside', value)
        } else {
            setInfo({ ...info, [name]: value })
        }
    }

    const selectedGlobal = global.includes(info.outside_country)

    return (
        <div>
            <InputGroup>
                <Search
                    label="Šalis"
                    options={useCountries}
                    value={info.outside_country}
                    name="outside_country"
                    onChange={handleChange}
                    required
                />
                {hasStates && (
                    <Search
                        type="text"
                        name="outside_state"
                        label="Valstija"
                        options={states[info.outside_country]}
                        value={info.outside_state}
                        onChange={handleChange}
                        required
                    />
                )}
                <Input
                    type="text"
                    name="outside_city"
                    label="Miestas"
                    value={info.outside_city}
                    onChange={handleChange}
                    required
                />
                <Input
                    type="text"
                    name="outside_address"
                    label="Adresas"
                    value={info.outside_address}
                    onChange={handleChange}
                    required
                />
                <Input
                    type="text"
                    name="outside_postal_code"
                    label="Pašto kodas"
                    value={info.outside_postal_code}
                    onChange={handleChange}
                    required
                />
            </InputGroup>
            {selectedGlobal && (
                <Infoblock className="mb30">
                    Muito mokesčiai {`${setup.dutiesPayer === 'sender' ? 'įtraukiami' : 'neįtraukiami'}`}.
                </Infoblock>
            )}
        </div>
    )
}
